module.exports = __webpack_public_path__ + "img/S1051431.5706e7d5.jpg";